import moment from 'moment-timezone';
import { getHoursOfDay } from './getHoursOfDay';

/**
 * Gets the hours in a day
 *
 * @param date - The date you want the hours for
 * @returns - An array with each hour of the day for the current locale on the date specified
 */
export function getHoursOfDayFor(date: Date): moment.Moment[] {
    return getHoursOfDay().map(hourOfDay => moment(date).hour(hourOfDay));
}
